import type { PlanDefinition, PlanDefinitionAction } from '@medplum/fhirtypes';

/**
 * The leaf actions of a PlanDefinition — the ones that materialize — flattened out of their groups.
 * A group (an action with nested `action`s) is structure, not work: it names a section of the protocol,
 * and only its leaves become items.
 *
 * Generic over any PlanDefinition, so it lives with the engine rather than with one protocol's
 * definition; every protocol and every reader of a protocol shares this one walk.
 */
export const leafActions = (planDefinition: PlanDefinition): PlanDefinitionAction[] => {
  const walk = (actions: PlanDefinitionAction[]): PlanDefinitionAction[] =>
    actions.flatMap((a) => (a.action?.length ? walk(a.action) : [a]));
  return walk(planDefinition.action ?? []);
};
